import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PlacesList from './PlacesList/PlacesList';
import PlaceEdit from './PlaceEdit/PlaceEdit';
import PlaceCreate from './PlaceCreate/PlaceCreate';
import PlaceDelete from './PlaceDelete/PlaceDelete';

const Places = ({ match }) => {
    return (
        <div className="Places">
            <ContainerWrapper container="places">
                <Route exact path={ match.path } component={PlacesList} />
                <Route exact path={ `${ match.url }/new` } component={PlaceCreate} />
                <Route exact path={ `${ match.url }/edit/:placeId` } component={PlaceEdit} />
                <Route exact path={ `${ match.url }/delete/:placeId` } component={PlaceDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Places;
